import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const BOLREPLENISHMENT_BASE = "/bolreplenishments";
const buildUrl = (endpoint) => BOLREPLENISHMENT_BASE + endpoint;

const bolreplenishmentSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        findAllBolreplenishments: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Bolreplenishments' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'findAllBolreplenishments', 'Bolreplenishments')
        }),
        findBolreplenishmentById: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'Bolreplenishments', id }],
        }),
        getBolreplenishmentLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/lines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (id) => [{ type: 'BolreplenishmentLines', id }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getBolreplenishmentLines', 'BolreplenishmentLines')
        }),
        createBolreplenishment: builder.mutation({
            query: info => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: info,
            }),
            invalidatesTags: [{ type: 'Bolreplenishments' }],
        }),
        updateBolreplenishment: builder.mutation({
            query: ({ id, ...info }) => ({
                url: buildUrl(`/${id}`),
                method: 'PUT',
                body: info,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Bolreplenishments', id }, { type: 'Bolreplenishments' }],
        }),
        deleteBolreplenishment: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Bolreplenishments', id }, { type: 'Bolreplenishments' }],
        }),
        approveBolreplenishment: builder.mutation({
            query: data => ({
                url: buildUrl(`/${data.bolReplenishmentId}/approve`),
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Bolreplenishments', id }, { type: 'Bolreplenishments' }],
        }),
        rejectBolreplenishment: builder.mutation({
            query: data => ({
                url: buildUrl(`/${data.bolReplenishmentId}/reject`),
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Bolreplenishments', id }, { type: 'Bolreplenishments' }],
        }),
        getAvailableWarehouses: builder.mutation({
            query: data => ({
                url: buildUrl(`/warehouses`),
                method: 'POST',
                body: data,
            }),
        }),

        getAvailableWarehousesStatus: builder.mutation({
           
            query: ({ processStatusId, webshopcredential }) => ({
                url: buildUrl(`/warehouses/${processStatusId}`), // param in URL
                method: 'POST',
                body: { webshopcredential }, // only send body data needed
            }),
        }),
        getAvailableTimeslots: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/timeslots`),
                method: 'GET',
            }),
        }),
        getAvailablePickupDates: builder.mutation({
            query: ({ id, carrierAmount }) => ({
                url: buildUrl(`/${id}/pickupdates`),
                method: 'POST',
                body: { carrierAmount },
            }),
        }),
        getPicklist: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/picklist`),
                method: 'GET',
            }),
        }),
        getCarrierLabel: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/carrierlabel`),
                method: 'GET',
            }),
        }),
        setBolreplenishmentTimeslot: builder.mutation({
            query: ({ id, dateSlot }) => ({
                url: buildUrl(`/${id}/settimeslot`),
                method: 'POST',
                body: { dateSlot },
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Bolreplenishments', id }, { type: 'Bolreplenishments' }],
        }),
        syncBolreplenishmentStatus: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/syncstatus`),
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'Bolreplenishments', id },
                { type: 'Bolreplenishments' },
                { type: 'BolreplenishmentLines', id },
                { type: 'LogsSingle' }
            ],
        }),
    })
});

export const {
    useFindAllBolreplenishmentsQuery,
    useGetAvailableWarehousesStatusMutation,
    useFindBolreplenishmentByIdQuery,
    useGetBolreplenishmentLinesQuery,
    useCreateBolreplenishmentMutation,
    useUpdateBolreplenishmentMutation,
    useDeleteBolreplenishmentMutation,
    useApproveBolreplenishmentMutation,
    useRejectBolreplenishmentMutation,
    useGetAvailableWarehousesMutation,
    useGetAvailableTimeslotsQuery,
    useGetAvailablePickupDatesMutation,
    useGetPicklistQuery,
    useGetCarrierLabelQuery,
    useSetBolreplenishmentTimeslotMutation,
    useSyncBolreplenishmentStatusMutation,
} = bolreplenishmentSlice;
